// DEPRECATED: Real-time subscriptions completely removed for performance
// Use manual refresh buttons instead

// Placeholder hook to prevent breaking existing imports
export const useRealtimeSubscriptions = () => {
  return {
    isEnabled: false,
    connectionState: 'DISABLED',
    isConnected: false
  };
};

// DEPRECATED: Use manual refresh instead
export const useFinancialDashboardRealtime = () => {
  return {
    isEnabled: false,
    connectionState: 'DISABLED',
    isConnected: false
  };
};

// DEPRECATED: Use manual refresh instead
export const useNegotiationsRealtime = () => {
  // No-op
};

// DEPRECATED: Use manual refresh instead
export const useCashFlowRealtime = () => {
  // No-op
};